<template>
  <div class="compatibility-cell">
    <ProgressCircle :isNone="props.params.data?.results?.compatibility === undefined" data-step="compatibility" :size="36" :stroke="5" :gapAngle="90" :percentage="percentage" />
  </div>
</template>

<script setup lang="ts">
import { ParticipantRow } from '@/types/participant';
import { ResultRow } from '@/types/results';
import type { ICellRendererParams } from 'ag-grid-community';

const props = defineProps<{
  params: ICellRendererParams<ResultRow>, // injected by AG Grid, contains `data`, `api`, etc.
}>();

const percentage = computed(() => {
  return (props.params.data?.results?.compatibility as number) * 100
})

</script>

<style lang="scss">
@import "@/assets/style/variables.scss";

.compatibility-cell {
  width: 100%;
  height: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
}
</style>